import BaseApi from './base'

class LogRoutine extends BaseApi {
  getLogRoutines = (query) => this.client.get(`admin/log-routine?${query}`)

  getCodeRoutines = () => this.client.get(`admin/log-routine/code-routine`)
}
export default new LogRoutine()
